// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__bNEVd","icon":"SortAdornment_icon__1IYQ8","up":"SortAdornment_up__2yR98","down":"SortAdornment_down__39Y8o","active":"SortAdornment_active__3djpn"};